// extracted by mini-css-extract-plugin
export default {"expandable":"expandable_expandable__9b-oa","expandableExpanded":"expandable_expandableExpanded__hNini"};